<template>
    <div class="md:tw-inline-block tw-relative">

        <button id="actionsMenuButton" @click="isDropdownOpen = ! isDropdownOpen" class="cu-btn tw-relative tw-mb-1">
            <i class="fa fa-spinner fa-pulse tw-mr-1" v-show="isLoading"></i>
            Aktion
            <i class="fa fa-chevron-down tw-ml-1"></i>
        </button>

        <div id="myDropdown" style="min-width: 250px;"
             class="dropdown-content tw-bg-white tw-absolute tw-overflow-auto tw-z-20 tw-rounded-md tw-pt-2 tw-pb-2 tw-border tw-border-navbar-secondary"
             v-show="isDropdownOpen"
             v-closable="{
                exclude: ['#actionsMenuButton', '#trialModal'],
                handler: 'onClose',
            }"
        >
            <template v-if="[MailStatus.STATUS_UNREAD, MailStatus.STATUS_READ, MailStatus.STATUS_INVITE_PHONE, MailStatus.STATUS_INVITE_INTERVIEW, MailStatus.STATUS_INVITE_TRIAL_WORK, MailStatus.STATUS_REINVITE_PHONE, MailStatus.STATUS_REINVITE_INTERVIEW, MailStatus.STATUS_REINVITE_TRIAL_WORK].indexOf(mail.status) !== -1">
                <div class="tw-inline-flex tw-px-4 tw-mb-1 tw-container tw-flex-wrap">
                    <div class="tw-w-1/2 tw-inline-flex">
                        <radio
                                initial-value="male"
                                id="sex_male"
                                name="sex"
                                v-model="applicantGender"
                        ></radio>
                        <label for="sex_male">Herr</label>
                    </div>
                    <div class="tw-w-1/2 tw-inline-flex">
                        <radio
                                initial-value="female"
                                id="sex_female"
                                name="sex"
                                v-model="applicantGender"
                        ></radio>
                        <label for="sex_female">Frau</label>
                    </div>

                    <div class="tw-w-full tw-text-danger-primary tw-text-sm" v-if="!! this.validationErrors.sex && this.validationErrors.sex.length > 0">
                        {{ this.validationErrors.sex[0] }}
                    </div>
                </div>

                <div class="tw-px-4">
                    <div class="cu-input-simple">
                        <input type="text" name="from_email" id="from_email" v-model="applicantName">
                    </div>

                    <div class="tw-text-danger-primary tw-text-sm" v-if="!! this.validationErrors.name && this.validationErrors.name.length > 0">
                        {{ this.validationErrors.name[0] }}
                    </div>
                </div>

                <hr class="tw-my-2">
            </template>

            <div class="tw-flex tw-flex-wrap">
                <template v-if="mail.status === MailStatus.STATUS_READ">
                    <a :href="`/application/${mail.id}/department/${department.id}/reject`"
                        class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                    >
                        Bewerbung ablehnen
                    </a>
                    <template v-if="[MailStatus.STATUS_INVITE_PHONE, MailStatus.STATUS_INVITE_INTERVIEW, MailStatus.STATUS_INVITE_TRIAL_WORK, MailStatus.STATUS_REINVITE_PHONE, MailStatus.STATUS_REINVITE_INTERVIEW, MailStatus.STATUS_REINVITE_TRIAL_WORK].indexOf(mail.status) !== -1">
                        <a :href="`/application/${mail.id}/department/${department.id}/revoke`"
                        class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                        >
                            Bewerbung zurückgezogen
                        </a>
                    </template>

                    <hr class="tw-my-2">

                    <div class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                         @click="triggerDepartmentAction(MailDepartmentStatus.STATUS_INVITE_PHONE)"
                    >
                        Telefongespräch einladen
                    </div>

                    <div class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                         @click="triggerDepartmentAction(MailDepartmentStatus.STATUS_INVITE_INTERVIEW)"
                    >
                        Bewerbungsgespräch einladen
                    </div>

                    <button type="button"
                            class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                            data-toggle="modal" 
                            data-target="#trialModal"
                    >
                        Probearbeiten einladen
                    </button>

                    <div class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                         @click="triggerDepartmentAction(MailDepartmentStatus.STATUS_HOLD)"
                    >
                        Auf Eis
                    </div>
                </template>
                
                <template v-else-if="[MailStatus.STATUS_USER_INVITED_TELKO, MailStatus.STATUS_USER_INVITED_TALK, MailStatus.STATUS_USER_INVITED_PROBE, MailStatus.STATUS_HOLD, MailStatus.STATUS_USER_INVITED_PROBE_AND_HR_MADE_PROBE_CONTRACT].indexOf(mail.status) > -1">
                    <a :href="`/application/${mail.id}/department/${department.id}/reject-after-appointment`"
                       class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                    >
                        Ablehnen (28 Tage nach Termin)
                    </a>

                    <a :href="`/application/${mail.id}/department/${department.id}/reject-directly`"
                       class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                    >
                        Direkt Ablehnen
                    </a>

                    <button type="button"
                            class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                            data-toggle="modal"
                            data-target="#rescheduleModal"
                    >
                        Termin verschieben
                    </button>

                    <template v-if="mail.status !== MailStatus.STATUS_HOLD">
                        <a :href="`/application/${mail.id}/department/${department.id}/hold`"
                           class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                        >
                            Auf Eis
                        </a>

                        <a :href="`/application/${mail.id}/contract`"
                           class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                        >
                            Vertrag
                        </a>
                    </template>

                    <button type="button"
                            class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                            data-toggle="modal" 
                            data-target="#revokeModal"
                    >
                        Bewerbung zurückgezogen
                    </button>

                    <template v-if="[MailStatus.STATUS_USER_INVITED_TELKO, MailStatus.STATUS_USER_INVITED_TALK, MailStatus.STATUS_USER_INVITED_PROBE].indexOf(mail.status) > -1">
                        <a :href="`/application/${mail.id}/department/${department.id}/revoke?failed_to_appear=1`"
                           class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                        >
                            <span v-if="[MailStatus.STATUS_USER_INVITED_TALK, MailStatus.STATUS_USER_INVITED_PROBE].indexOf(mail.status) > -1">
                                Nicht erschienen
                            </span>
                            
                            <span v-else>
                                Nicht erreicht
                            </span>
                        </a>
                    </template>

                    <a :href="`/application/${mail.id}/department/${department.id}/invite/interview`" 
                       class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                       v-if="mail.status === MailStatus.STATUS_USER_INVITED_TELKO"
                    >
                        Bewerbungsgespräch einladen
                    </a>
                    
                    <button type="button"
                            class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                            data-toggle="modal" 
                            data-target="#trialModal"
                            v-if="[MailStatus.STATUS_USER_INVITED_TELKO, MailStatus.STATUS_USER_INVITED_TALK].indexOf(mail.status) > -1"
                    >
                        Probearbeiten einladen
                    </button>
                </template>

                <template v-else>
                    <template v-if="mail.status !== MailStatus.STATUS_HIRED && mail.status !== MailStatus.STATUS_PROBE">
                        <a :href="`/application/${mail.id}/department/${department.id}/revoke`"
                           class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                        >
                            Bewerbung zurückgezogen
                        </a>
                    </template>

                    <template v-if="mail.status === MailStatus.STATUS_PROBE">
                        <a :href="`/application/${mail.id}/user-rejected`"
                           class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                        >
                            Bewerber hat abgesagt
                        </a>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Radio from "../Radio";
    import CheckBox from "../CheckBox";
    import BorderedInput from "../BorderedInput";

    const MailStatus = {
        STATUS_UNREAD: 1,
        STATUS_READ: 2,
        STATUS_TELKO: 3,
        STATUS_TALK: 4,
        STATUS_PROBE: 5,
        STATUS_HOLD: 6,
        STATUS_CONTRACT: 7,
        STATUS_EMPLOYED: 8,
        STATUS_DENIED: 9,
        STATUS_USER_REJECTED: 10,
        STATUS_USER_INVITED_TELKO: 11,
        STATUS_USER_INVITED_TALK: 12,
        STATUS_USER_INVITED_PROBE: 13,
        STATUS_DENIED_AFTER_APPOINTMENT: 14,
        STATUS_DENIED_CONTRACT: 15,
        STATUS_HIRED: 16,
        STATUS_AUTOMATIC_DENIED: 17,
        STATUS_AUTOMATIC_DENIED_NOT_REACHED: 18,
        STATUS_AUTOMATIC_REFUSED: 19,
        STATUS_USER_INVITED_PROBE_AND_HR_MADE_PROBE_CONTRACT: 20,
    };

    const MailDepartmentStatus = {
        STATUS_UNREAD: 'unread',
        STATUS_READ: 'read',
        STATUS_DENIED: 'denied',
        STATUS_INVITE_PHONE: 'invite phone',
        STATUS_INVITE_INTERVIEW: 'invite interview',
        STATUS_INVITE_TRIAL_WORK: 'invite trial work',
        STATUS_REINVITE_PHONE: 'reinvite phone',
        STATUS_REINVITE_INTERVIEW: 'reinvite interview',
        STATUS_REINVITE_TRIAL_WORK: 'reinvite trial work',
        STATUS_USER_REJECTED: 'user rejected',
        STATUS_INVITED_PHONE: 'invited phone',
        STATUS_INVITED_INTERVIEW: 'invited interview',
        STATUS_INVITED_TRIAL_WORK: 'invited trial work',
        STATUS_REINVITED_PHONE: 'reinvited phone',
        STATUS_REINVITED_INTERVIEW: 'reinvited interview',
        STATUS_REINVITED_TRIAL_WORK: 'reinvited trial work',
        STATUS_DENIED_AFTER_APPOINTMENT: 'denied after appointment',
        STATUS_HOLD: 'hold',
        STATUS_CONTRACT: 'contract',
        STATUS_DENIED_CONTRACT: 'denied contract',
        STATUS_HIRED: 'hired',
        STATUS_AUTOMATIC_DENIED: 'auto denied',
        STATUS_AUTOMATIC_DENIED_NOT_REACHED: 'not reached auto denied',
        STATUS_AUTOMATIC_REFUSED: 'auto refused',
    };

    export default {
        components: {
            Radio,
            CheckBox,
            BorderedInput,
        },

        props: {
            mail: {
                required: true,
                type: Object,
            },
            department: {
                required: false,
                type: Object,
                default: null,
            },
            hasPermissionAllDepartments: {
                required: true,
                type: Boolean,
            }, 
        },

        data() {
            return {
                isDropdownOpen: false,
                isLoading: false,
                csrfToken: null,
                MailStatus: MailStatus,
                MailDepartmentStatus: MailDepartmentStatus,

                applicantGender: null,
                applicantName: this.mail.from_name,

                validationErrors: {},
            }
        },

        methods: {
            onClose() {
                this.isDropdownOpen = false;
            },
            triggerDepartmentAction(action) {
                this.isLoading = true;

                this.validationErrors = {};
                let url = this.hasPermissionAllDepartments ? "/applications/inbox/all" : "/applications/inbox/" + this.department.id;

                axios
                    .post('/application-department-action', {
                        action_type: action,
                        mail_id: this.mail.id,
                        current_department_id: this.department.id,
                        name: this.applicantName,
                        sex: this.applicantGender,
                        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
                    })
                    .then(response => {
                        this.isLoading = false;
                        window.location = url;
                    })
                    .catch(error => {
                        if (!! error.response.data.errors) {
                            this.validationErrors = error.response.data.errors;
                        }
                    })
                    .then(() => {
                        this.isLoading = false;
                    });
            }
        },

        mounted() {
            this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
        },

        computed: {
            minDate() {
                const today = new Date();
                const tomorrow = new Date(today);
                tomorrow.setDate(today.getDate() + 1);
                return tomorrow.toISOString().split("T")[0];
            },
            maxDate() {
                const today = new Date();
                const sixMonthsFromToday = new Date(today);
                sixMonthsFromToday.setMonth(today.getMonth() + 6);
                return sixMonthsFromToday.toISOString().split("T")[0];
            },
        }
    }
</script>